import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ReviewRequestStatus = /*#__PURE__*/function (ReviewRequestStatus) {
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_NOT_SENT"] = 0] = "REVIEW_REQUEST_STATUS_NOT_SENT";
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_LEFT_REVIEW"] = 1] = "REVIEW_REQUEST_STATUS_LEFT_REVIEW";
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_DELIVERED"] = 2] = "REVIEW_REQUEST_STATUS_DELIVERED";
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_BOUNCED"] = 3] = "REVIEW_REQUEST_STATUS_BOUNCED";
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_OPENED"] = 4] = "REVIEW_REQUEST_STATUS_OPENED";
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_CLICKED"] = 5] = "REVIEW_REQUEST_STATUS_CLICKED";
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_CLICKED_POSITIVE"] = 6] = "REVIEW_REQUEST_STATUS_CLICKED_POSITIVE";
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_CLICKED_NEGATIVE"] = 7] = "REVIEW_REQUEST_STATUS_CLICKED_NEGATIVE";
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_UNSUBSCRIBE"] = 8] = "REVIEW_REQUEST_STATUS_UNSUBSCRIBE";
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_SPAM_REPORT"] = 9] = "REVIEW_REQUEST_STATUS_SPAM_REPORT";
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_SENDING"] = 10] = "REVIEW_REQUEST_STATUS_SENDING";
  ReviewRequestStatus[ReviewRequestStatus["REVIEW_REQUEST_STATUS_DROPPED"] = 11] = "REVIEW_REQUEST_STATUS_DROPPED";
  return ReviewRequestStatus;
}(ReviewRequestStatus || {});
var SmsStatusCode = /*#__PURE__*/function (SmsStatusCode) {
  SmsStatusCode[SmsStatusCode["SMS_STATUS_CODE_SUCCESS"] = 0] = "SMS_STATUS_CODE_SUCCESS";
  SmsStatusCode[SmsStatusCode["SMS_STATUS_CODE_QUEUE_FULL"] = 1] = "SMS_STATUS_CODE_QUEUE_FULL";
  SmsStatusCode[SmsStatusCode["SMS_STATUS_CODE_ACCOUNT_SUSPENDED"] = 2] = "SMS_STATUS_CODE_ACCOUNT_SUSPENDED";
  SmsStatusCode[SmsStatusCode["SMS_STATUS_CODE_UNREACHABLE_DESTINATION"] = 3] = "SMS_STATUS_CODE_UNREACHABLE_DESTINATION";
  SmsStatusCode[SmsStatusCode["SMS_STATUS_CODE_MESSAGE_BLOCKED"] = 4] = "SMS_STATUS_CODE_MESSAGE_BLOCKED";
  SmsStatusCode[SmsStatusCode["SMS_STATUS_CODE_UNKNOWN_DESTINATION"] = 5] = "SMS_STATUS_CODE_UNKNOWN_DESTINATION";
  SmsStatusCode[SmsStatusCode["SMS_STATUS_CODE_LANDLINE_NUMBER"] = 6] = "SMS_STATUS_CODE_LANDLINE_NUMBER";
  SmsStatusCode[SmsStatusCode["SMS_STATUS_CODE_CARRIER_VIOLATION"] = 7] = "SMS_STATUS_CODE_CARRIER_VIOLATION";
  SmsStatusCode[SmsStatusCode["SMS_STATUS_CODE_UNKNOWN_ERROR"] = 8] = "SMS_STATUS_CODE_UNKNOWN_ERROR";
  SmsStatusCode[SmsStatusCode["SMS_STATUS_CODE_UNSUBSCRIBED"] = 9] = "SMS_STATUS_CODE_UNSUBSCRIBED";
  return SmsStatusCode;
}(SmsStatusCode || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AutomationType = /*#__PURE__*/function (AutomationType) {
  AutomationType[AutomationType["AUTOMATION_TYPE_NONE"] = 0] = "AUTOMATION_TYPE_NONE";
  AutomationType[AutomationType["AUTOMATION_TYPE_REVIEW_REMINDER"] = 1] = "AUTOMATION_TYPE_REVIEW_REMINDER";
  return AutomationType;
}(AutomationType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var RequestEventType = /*#__PURE__*/function (RequestEventType) {
  RequestEventType[RequestEventType["REQUEST_EVENT_TYPE_UNKNOWN"] = 0] = "REQUEST_EVENT_TYPE_UNKNOWN";
  RequestEventType[RequestEventType["REQUEST_EVENT_TYPE_EMAIL"] = 1] = "REQUEST_EVENT_TYPE_EMAIL";
  RequestEventType[RequestEventType["REQUEST_EVENT_TYPE_SMS"] = 2] = "REQUEST_EVENT_TYPE_SMS";
  return RequestEventType;
}(RequestEventType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CreateError = /*#__PURE__*/function (CreateError) {
  CreateError[CreateError["CREATE_ERROR_NO_ERRORS"] = 0] = "CREATE_ERROR_NO_ERRORS";
  CreateError[CreateError["CREATE_ERROR_EMAIL_OR_PHONE_REQUIRED"] = 1] = "CREATE_ERROR_EMAIL_OR_PHONE_REQUIRED";
  CreateError[CreateError["CREATE_ERROR_INVALID_EMAIL"] = 2] = "CREATE_ERROR_INVALID_EMAIL";
  CreateError[CreateError["CREATE_ERROR_INVALID_PHONE"] = 3] = "CREATE_ERROR_INVALID_PHONE";
  CreateError[CreateError["CREATE_ERROR_INVALID_FIRST_NAME"] = 4] = "CREATE_ERROR_INVALID_FIRST_NAME";
  CreateError[CreateError["CREATE_ERROR_INVALID_LAST_NAME"] = 5] = "CREATE_ERROR_INVALID_LAST_NAME";
  CreateError[CreateError["CREATE_ERROR_INVALID_COUNTRY"] = 6] = "CREATE_ERROR_INVALID_COUNTRY";
  CreateError[CreateError["CREATE_ERROR_INVALID_STATE"] = 7] = "CREATE_ERROR_INVALID_STATE";
  return CreateError;
}(CreateError || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_NONE"] = 0] = "SORT_DIRECTION_NONE";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 2] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection || {});
// *********************************

function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Customer {
  static fromProto(proto) {
    let m = new Customer();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.emailRequestLastDateSent) {
      m.emailRequestLastDateSent = new Date(proto.emailRequestLastDateSent);
    }
    if (proto.smsRequestLastDateSent) {
      m.smsRequestLastDateSent = new Date(proto.smsRequestLastDateSent);
    }
    if (proto.emailReviewRequestStatus) {
      m.emailReviewRequestStatus = enumStringToValue$5(ReviewRequestStatus, proto.emailReviewRequestStatus);
    }
    if (proto.smsReviewRequestStatus) {
      m.smsReviewRequestStatus = enumStringToValue$5(ReviewRequestStatus, proto.smsReviewRequestStatus);
    }
    if (proto.emailLastClickedSource) {
      m.emailLastClickedSource = parseInt(proto.emailLastClickedSource, 10);
    }
    if (proto.review) {
      m.review = CustomerReview.fromProto(proto.review);
    }
    if (proto.smsStatusCode) {
      m.smsStatusCode = enumStringToValue$5(SmsStatusCode, proto.smsStatusCode);
    }
    if (proto.smsLastClickedSource) {
      m.smsLastClickedSource = parseInt(proto.smsLastClickedSource, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.emailRequestLastDateSent !== 'undefined' && this.emailRequestLastDateSent !== null) {
      toReturn['emailRequestLastDateSent'] = 'toApiJson' in this.emailRequestLastDateSent ? this.emailRequestLastDateSent.toApiJson() : this.emailRequestLastDateSent;
    }
    if (typeof this.smsRequestLastDateSent !== 'undefined' && this.smsRequestLastDateSent !== null) {
      toReturn['smsRequestLastDateSent'] = 'toApiJson' in this.smsRequestLastDateSent ? this.smsRequestLastDateSent.toApiJson() : this.smsRequestLastDateSent;
    }
    if (typeof this.emailReviewRequestStatus !== 'undefined') {
      toReturn['emailReviewRequestStatus'] = this.emailReviewRequestStatus;
    }
    if (typeof this.smsReviewRequestStatus !== 'undefined') {
      toReturn['smsReviewRequestStatus'] = this.smsReviewRequestStatus;
    }
    if (typeof this.emailLastClickedSource !== 'undefined') {
      toReturn['emailLastClickedSource'] = this.emailLastClickedSource;
    }
    if (typeof this.employeeFirstName !== 'undefined') {
      toReturn['employeeFirstName'] = this.employeeFirstName;
    }
    if (typeof this.employeeLastName !== 'undefined') {
      toReturn['employeeLastName'] = this.employeeLastName;
    }
    if (typeof this.tag !== 'undefined') {
      toReturn['tag'] = this.tag;
    }
    if (typeof this.review !== 'undefined' && this.review !== null) {
      toReturn['review'] = 'toApiJson' in this.review ? this.review.toApiJson() : this.review;
    }
    if (typeof this.smsStatusCode !== 'undefined') {
      toReturn['smsStatusCode'] = this.smsStatusCode;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.smsLastClickedSource !== 'undefined') {
      toReturn['smsLastClickedSource'] = this.smsLastClickedSource;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    return toReturn;
  }
}
class CustomerReview {
  static fromProto(proto) {
    let m = new CustomerReview();
    m = Object.assign(m, proto);
    if (proto.starRating) {
      m.starRating = parseInt(proto.starRating, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.starRating !== 'undefined') {
      toReturn['starRating'] = this.starRating;
    }
    if (typeof this.reviewUrl !== 'undefined') {
      toReturn['reviewUrl'] = this.reviewUrl;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CustomerRequestEvent {
  static fromProto(proto) {
    let m = new CustomerRequestEvent();
    m = Object.assign(m, proto);
    if (proto.requestEventType) {
      m.requestEventType = enumStringToValue$4(RequestEventType, proto.requestEventType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.requestEventType !== 'undefined') {
      toReturn['requestEventType'] = this.requestEventType;
    }
    return toReturn;
  }
}
class ReviewRequestEvent {
  static fromProto(proto) {
    let m = new ReviewRequestEvent();
    m = Object.assign(m, proto);
    if (proto.customerRequestEvents) {
      m.customerRequestEvents = proto.customerRequestEvents.map(CustomerRequestEvent.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.automationType) {
      m.automationType = enumStringToValue$4(AutomationType, proto.automationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requestEventId !== 'undefined') {
      toReturn['requestEventId'] = this.requestEventId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customerRequestEvents !== 'undefined' && this.customerRequestEvents !== null) {
      toReturn['customerRequestEvents'] = 'toApiJson' in this.customerRequestEvents ? this.customerRequestEvents.toApiJson() : this.customerRequestEvents;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.automationType !== 'undefined') {
      toReturn['automationType'] = this.automationType;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Attribute {
  static fromProto(proto) {
    let m = new Attribute();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class CreateCustomerAndSendDefaultReviewRequestRequest {
  static fromProto(proto) {
    let m = new CreateCustomerAndSendDefaultReviewRequestRequest();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = Customer.fromProto(proto.customer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    if (typeof this.responseToken !== 'undefined') {
      toReturn['responseToken'] = this.responseToken;
    }
    return toReturn;
  }
}
class CreateCustomerAndSendDefaultReviewRequestResponse {
  static fromProto(proto) {
    let m = new CreateCustomerAndSendDefaultReviewRequestResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class CreateCustomerRequest {
  static fromProto(proto) {
    let m = new CreateCustomerRequest();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = Customer.fromProto(proto.customer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.employeeFirstName !== 'undefined') {
      toReturn['employeeFirstName'] = this.employeeFirstName;
    }
    if (typeof this.employeeLastName !== 'undefined') {
      toReturn['employeeLastName'] = this.employeeLastName;
    }
    if (typeof this.tag !== 'undefined') {
      toReturn['tag'] = this.tag;
    }
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    return toReturn;
  }
}
class CreateCustomerResponse {
  static fromProto(proto) {
    let m = new CreateCustomerResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class CreateMultiCustomerError {
  static fromProto(proto) {
    let m = new CreateMultiCustomerError();
    m = Object.assign(m, proto);
    if (proto.index) {
      m.index = parseInt(proto.index, 10);
    }
    if (proto.errors) {
      m.errors = proto.errors.map(v => enumStringToValue$2(CreateError, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.index !== 'undefined') {
      toReturn['index'] = this.index;
    }
    if (typeof this.errors !== 'undefined') {
      toReturn['errors'] = this.errors;
    }
    return toReturn;
  }
}
class CreateMultiCustomerRequest {
  static fromProto(proto) {
    let m = new CreateMultiCustomerRequest();
    m = Object.assign(m, proto);
    if (proto.customers) {
      m.customers = proto.customers.map(Customer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customers !== 'undefined' && this.customers !== null) {
      toReturn['customers'] = 'toApiJson' in this.customers ? this.customers.toApiJson() : this.customers;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class CreateMultiCustomerResponse {
  static fromProto(proto) {
    let m = new CreateMultiCustomerResponse();
    m = Object.assign(m, proto);
    if (proto.customers) {
      m.customers = proto.customers.map(Customer.fromProto);
    }
    if (proto.errors) {
      m.errors = proto.errors.map(CreateMultiCustomerError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customers !== 'undefined' && this.customers !== null) {
      toReturn['customers'] = 'toApiJson' in this.customers ? this.customers.toApiJson() : this.customers;
    }
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    return toReturn;
  }
}
class CreateReviewRequestEventRequest {
  static fromProto(proto) {
    let m = new CreateReviewRequestEventRequest();
    m = Object.assign(m, proto);
    if (proto.customerRequestEvents) {
      m.customerRequestEvents = proto.customerRequestEvents.map(CustomerRequestEvent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customerRequestEvents !== 'undefined' && this.customerRequestEvents !== null) {
      toReturn['customerRequestEvents'] = 'toApiJson' in this.customerRequestEvents ? this.customerRequestEvents.toApiJson() : this.customerRequestEvents;
    }
    return toReturn;
  }
}
class CreateReviewRequestEventResponse {
  static fromProto(proto) {
    let m = new CreateReviewRequestEventResponse();
    m = Object.assign(m, proto);
    if (proto.reviewRequestEvent) {
      m.reviewRequestEvent = ReviewRequestEvent.fromProto(proto.reviewRequestEvent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewRequestEvent !== 'undefined' && this.reviewRequestEvent !== null) {
      toReturn['reviewRequestEvent'] = 'toApiJson' in this.reviewRequestEvent ? this.reviewRequestEvent.toApiJson() : this.reviewRequestEvent;
    }
    return toReturn;
  }
}
class CustomerExistsRequest {
  static fromProto(proto) {
    let m = new CustomerExistsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    return toReturn;
  }
}
class CustomerExistsResponse {
  static fromProto(proto) {
    let m = new CustomerExistsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerExists !== 'undefined') {
      toReturn['customerExists'] = this.customerExists;
    }
    return toReturn;
  }
}
class CustomerFilters {
  static fromProto(proto) {
    let m = new CustomerFilters();
    m = Object.assign(m, proto);
    if (proto.emailStatus) {
      m.emailStatus = proto.emailStatus.map(v => enumStringToValue$2(ReviewRequestStatus, v));
    }
    if (proto.smsStatus) {
      m.smsStatus = proto.smsStatus.map(v => enumStringToValue$2(ReviewRequestStatus, v));
    }
    if (proto.created) {
      m.created = DateRangeFilter.fromProto(proto.created);
    }
    if (proto.lastRequested) {
      m.lastRequested = DateRangeFilter.fromProto(proto.lastRequested);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailStatus !== 'undefined') {
      toReturn['emailStatus'] = this.emailStatus;
    }
    if (typeof this.smsStatus !== 'undefined') {
      toReturn['smsStatus'] = this.smsStatus;
    }
    if (typeof this.tag !== 'undefined') {
      toReturn['tag'] = this.tag;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.lastRequested !== 'undefined' && this.lastRequested !== null) {
      toReturn['lastRequested'] = 'toApiJson' in this.lastRequested ? this.lastRequested.toApiJson() : this.lastRequested;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.negateTags !== 'undefined') {
      toReturn['negateTags'] = this.negateTags;
    }
    if (typeof this.customerIds !== 'undefined') {
      toReturn['customerIds'] = this.customerIds;
    }
    return toReturn;
  }
}
class DateRangeFilter {
  static fromProto(proto) {
    let m = new DateRangeFilter();
    m = Object.assign(m, proto);
    if (proto.beginRange) {
      m.beginRange = new Date(proto.beginRange);
    }
    if (proto.endRange) {
      m.endRange = new Date(proto.endRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined' && this.beginRange !== null) {
      toReturn['beginRange'] = 'toApiJson' in this.beginRange ? this.beginRange.toApiJson() : this.beginRange;
    }
    if (typeof this.endRange !== 'undefined' && this.endRange !== null) {
      toReturn['endRange'] = 'toApiJson' in this.endRange ? this.endRange.toApiJson() : this.endRange;
    }
    return toReturn;
  }
}
class DeleteCustomerRequest {
  static fromProto(proto) {
    let m = new DeleteCustomerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetCustomerRequest {
  static fromProto(proto) {
    let m = new GetCustomerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetCustomerResponse {
  static fromProto(proto) {
    let m = new GetCustomerResponse();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = Customer.fromProto(proto.customer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    return toReturn;
  }
}
class GetMultiCustomerForBusinessRequest {
  static fromProto(proto) {
    let m = new GetMultiCustomerForBusinessRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerIds !== 'undefined') {
      toReturn['customerIds'] = this.customerIds;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetMultiCustomerForBusinessResponse {
  static fromProto(proto) {
    let m = new GetMultiCustomerForBusinessResponse();
    m = Object.assign(m, proto);
    if (proto.customers) {
      m.customers = proto.customers.map(Customer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customers !== 'undefined' && this.customers !== null) {
      toReturn['customers'] = 'toApiJson' in this.customers ? this.customers.toApiJson() : this.customers;
    }
    return toReturn;
  }
}
class GetQRCodeForURLRequest {
  static fromProto(proto) {
    let m = new GetQRCodeForURLRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class GetQRCodeForURLResponse {
  static fromProto(proto) {
    let m = new GetQRCodeForURLResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.qrCode !== 'undefined') {
      toReturn['qrCode'] = this.qrCode;
    }
    return toReturn;
  }
}
class HeaderMapping {
  static fromProto(proto) {
    let m = new HeaderMapping();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.employeeFirstName !== 'undefined') {
      toReturn['employeeFirstName'] = this.employeeFirstName;
    }
    if (typeof this.employeeLastName !== 'undefined') {
      toReturn['employeeLastName'] = this.employeeLastName;
    }
    if (typeof this.tag !== 'undefined') {
      toReturn['tag'] = this.tag;
    }
    return toReturn;
  }
}
class ListBusinessTagsRequest {
  static fromProto(proto) {
    let m = new ListBusinessTagsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ListBusinessTagsResponse {
  static fromProto(proto) {
    let m = new ListBusinessTagsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tag !== 'undefined') {
      toReturn['tag'] = this.tag;
    }
    return toReturn;
  }
}
class ListCustomersRequest {
  static fromProto(proto) {
    let m = new ListCustomersRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = CustomerFilters.fromProto(proto.filters);
    }
    if (proto.sortingOptions) {
      m.sortingOptions = proto.sortingOptions.map(SortingOption.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.sortingOptions !== 'undefined' && this.sortingOptions !== null) {
      toReturn['sortingOptions'] = 'toApiJson' in this.sortingOptions ? this.sortingOptions.toApiJson() : this.sortingOptions;
    }
    return toReturn;
  }
}
class ListCustomersResponse {
  static fromProto(proto) {
    let m = new ListCustomersResponse();
    m = Object.assign(m, proto);
    if (proto.customers) {
      m.customers = proto.customers.map(Customer.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customers !== 'undefined' && this.customers !== null) {
      toReturn['customers'] = 'toApiJson' in this.customers ? this.customers.toApiJson() : this.customers;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListOriginsRequest {
  static fromProto(proto) {
    let m = new ListOriginsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ListOriginsResponse {
  static fromProto(proto) {
    let m = new ListOriginsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origins !== 'undefined') {
      toReturn['origins'] = this.origins;
    }
    return toReturn;
  }
}
class ListReviewRequestEventRequest {
  static fromProto(proto) {
    let m = new ListReviewRequestEventRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListReviewRequestEventResponse {
  static fromProto(proto) {
    let m = new ListReviewRequestEventResponse();
    m = Object.assign(m, proto);
    if (proto.reviewRequestEvents) {
      m.reviewRequestEvents = proto.reviewRequestEvents.map(ReviewRequestEvent.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewRequestEvents !== 'undefined' && this.reviewRequestEvents !== null) {
      toReturn['reviewRequestEvents'] = 'toApiJson' in this.reviewRequestEvents ? this.reviewRequestEvents.toApiJson() : this.reviewRequestEvents;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class MultilocationSendReviewRequestsCSVRequest {
  static fromProto(proto) {
    let m = new MultilocationSendReviewRequestsCSVRequest();
    m = Object.assign(m, proto);
    if (proto.mapping) {
      m.mapping = HeaderMapping.fromProto(proto.mapping);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.filePath !== 'undefined') {
      toReturn['filePath'] = this.filePath;
    }
    if (typeof this.mapping !== 'undefined' && this.mapping !== null) {
      toReturn['mapping'] = 'toApiJson' in this.mapping ? this.mapping.toApiJson() : this.mapping;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class SendReviewRequestEmailRequest {
  static fromProto(proto) {
    let m = new SendReviewRequestEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class SendReviewRequestSmsRequest {
  static fromProto(proto) {
    let m = new SendReviewRequestSmsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class SendReviewRequestToDefaultTemplateRequest {
  static fromProto(proto) {
    let m = new SendReviewRequestToDefaultTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class SendSMSRequest {
  static fromProto(proto) {
    let m = new SendSMSRequest();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.customerPhoneNumber !== 'undefined') {
      toReturn['customerPhoneNumber'] = this.customerPhoneNumber;
    }
    if (typeof this.messageToSend !== 'undefined') {
      toReturn['messageToSend'] = this.messageToSend;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    return toReturn;
  }
}
class SortingOption {
  static fromProto(proto) {
    let m = new SortingOption();
    m = Object.assign(m, proto);
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue$2(SortDirection, proto.sortDirection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.columnName !== 'undefined') {
      toReturn['columnName'] = this.columnName;
    }
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    return toReturn;
  }
}
class UpdateCustomerRequest {
  static fromProto(proto) {
    let m = new UpdateCustomerRequest();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = Customer.fromProto(proto.customer);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class StartTrustHubRegistrationRequest {
  static fromProto(proto) {
    let m = new StartTrustHubRegistrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetReviewSourceSettingsRequest {
  static fromProto(proto) {
    let m = new GetReviewSourceSettingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetReviewSourceSettingsResponse {
  static fromProto(proto) {
    let m = new GetReviewSourceSettingsResponse();
    m = Object.assign(m, proto);
    if (proto.reviewSources) {
      m.reviewSources = proto.reviewSources.map(ReviewSources.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewSources !== 'undefined' && this.reviewSources !== null) {
      toReturn['reviewSources'] = 'toApiJson' in this.reviewSources ? this.reviewSources.toApiJson() : this.reviewSources;
    }
    if (typeof this.selectedSourceIds !== 'undefined') {
      toReturn['selectedSourceIds'] = this.selectedSourceIds;
    }
    return toReturn;
  }
}
class ReviewSources {
  static fromProto(proto) {
    let m = new ReviewSources();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.iconClass !== 'undefined') {
      toReturn['iconClass'] = this.iconClass;
    }
    if (typeof this.hasListings !== 'undefined') {
      toReturn['hasListings'] = this.hasListings;
    }
    if (typeof this.hasWarning !== 'undefined') {
      toReturn['hasWarning'] = this.hasWarning;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.overriddenUrl !== 'undefined') {
      toReturn['overriddenUrl'] = this.overriddenUrl;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'customer-voice-service-api.vendasta-local.com',
  'test': '',
  'demo': 'customer-voice-service-api-demo.apigateway.co',
  'prod': 'customer-voice-service-api-prod.apigateway.co',
  'production': 'customer-voice-service-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CustomerVoiceApiService = /*#__PURE__*/(() => {
  class CustomerVoiceApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listCustomers(r) {
      const request = r.toApiJson ? r : new ListCustomersRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/ListCustomers", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCustomersResponse.fromProto(resp)));
    }
    createCustomer(r) {
      const request = r.toApiJson ? r : new CreateCustomerRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/CreateCustomer", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCustomerResponse.fromProto(resp)));
    }
    createMultiCustomers(r) {
      const request = r.toApiJson ? r : new CreateMultiCustomerRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/CreateMultiCustomers", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateMultiCustomerResponse.fromProto(resp)));
    }
    sendReviewRequestToDefaultTemplate(r) {
      const request = r.toApiJson ? r : new SendReviewRequestToDefaultTemplateRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/SendReviewRequestToDefaultTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendReviewRequestEmail(r) {
      const request = r.toApiJson ? r : new SendReviewRequestEmailRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/SendReviewRequestEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendReviewRequestSms(r) {
      const request = r.toApiJson ? r : new SendReviewRequestSmsRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/SendReviewRequestSms", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateCustomer(r) {
      const request = r.toApiJson ? r : new UpdateCustomerRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/UpdateCustomer", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteCustomer(r) {
      const request = r.toApiJson ? r : new DeleteCustomerRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/DeleteCustomer", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getCustomer(r) {
      const request = r.toApiJson ? r : new GetCustomerRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/GetCustomer", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCustomerResponse.fromProto(resp)));
    }
    getMultiCustomerForBusiness(r) {
      const request = r.toApiJson ? r : new GetMultiCustomerForBusinessRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/GetMultiCustomerForBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCustomerForBusinessResponse.fromProto(resp)));
    }
    listBusinessTags(r) {
      const request = r.toApiJson ? r : new ListBusinessTagsRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/ListBusinessTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBusinessTagsResponse.fromProto(resp)));
    }
    customerExists(r) {
      const request = r.toApiJson ? r : new CustomerExistsRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/CustomerExists", request.toApiJson(), this.apiOptions()).pipe(map(resp => CustomerExistsResponse.fromProto(resp)));
    }
    multilocationSendReviewRequestsCsv(r) {
      const request = r.toApiJson ? r : new MultilocationSendReviewRequestsCSVRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/MultilocationSendReviewRequestsCSV", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createReviewRequestEvent(r) {
      const request = r.toApiJson ? r : new CreateReviewRequestEventRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/CreateReviewRequestEvent", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateReviewRequestEventResponse.fromProto(resp)));
    }
    listReviewRequestEvents(r) {
      const request = r.toApiJson ? r : new ListReviewRequestEventRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/ListReviewRequestEvents", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListReviewRequestEventResponse.fromProto(resp)));
    }
    listOrigins(r) {
      const request = r.toApiJson ? r : new ListOriginsRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/ListOrigins", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListOriginsResponse.fromProto(resp)));
    }
    createCustomerAndSendDefaultReviewRequest(r) {
      const request = r.toApiJson ? r : new CreateCustomerAndSendDefaultReviewRequestRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/CreateCustomerAndSendDefaultReviewRequest", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCustomerAndSendDefaultReviewRequestResponse.fromProto(resp)));
    }
    sendSms(r) {
      const request = r.toApiJson ? r : new SendSMSRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/SendSMS", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getQrCodeForUrl(r) {
      const request = r.toApiJson ? r : new GetQRCodeForURLRequest(r);
      return this.http.post(this._host + "/customervoice.v1.CustomerVoice/GetQRCodeForURL", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetQRCodeForURLResponse.fromProto(resp)));
    }
  }
  CustomerVoiceApiService.ɵfac = function CustomerVoiceApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CustomerVoiceApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  CustomerVoiceApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CustomerVoiceApiService,
    factory: CustomerVoiceApiService.ɵfac,
    providedIn: 'root'
  });
  return CustomerVoiceApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ListingsApiService = /*#__PURE__*/(() => {
  class ListingsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getReviewSourceSettings(r) {
      const request = r.toApiJson ? r : new GetReviewSourceSettingsRequest(r);
      return this.http.post(this._host + "/customervoice.v1.ListingsService/GetReviewSourceSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetReviewSourceSettingsResponse.fromProto(resp)));
    }
  }
  ListingsApiService.ɵfac = function ListingsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListingsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ListingsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListingsApiService,
    factory: ListingsApiService.ɵfac,
    providedIn: 'root'
  });
  return ListingsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let TwilioApiService = /*#__PURE__*/(() => {
  class TwilioApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    startTrustHubRegistration(r) {
      const request = r.toApiJson ? r : new StartTrustHubRegistrationRequest(r);
      return this.http.post(this._host + "/customervoice.v1.Twilio/StartTrustHubRegistration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  TwilioApiService.ɵfac = function TwilioApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TwilioApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TwilioApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TwilioApiService,
    factory: TwilioApiService.ɵfac,
    providedIn: 'root'
  });
  return TwilioApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Attribute, AutomationType, CreateCustomerAndSendDefaultReviewRequestRequest, CreateCustomerAndSendDefaultReviewRequestResponse, CreateCustomerRequest, CreateCustomerResponse, CreateError, CreateMultiCustomerError, CreateMultiCustomerRequest, CreateMultiCustomerResponse, CreateReviewRequestEventRequest, CreateReviewRequestEventResponse, Customer, CustomerExistsRequest, CustomerExistsResponse, CustomerFilters, CustomerRequestEvent, CustomerReview, CustomerVoiceApiService, DateRangeFilter, DeleteCustomerRequest, FieldMask, GetCustomerRequest, GetCustomerResponse, GetMultiCustomerForBusinessRequest, GetMultiCustomerForBusinessResponse, GetQRCodeForURLRequest, GetQRCodeForURLResponse, GetReviewSourceSettingsRequest, GetReviewSourceSettingsResponse, HeaderMapping, HostService, ListBusinessTagsRequest, ListBusinessTagsResponse, ListCustomersRequest, ListCustomersResponse, ListOriginsRequest, ListOriginsResponse, ListReviewRequestEventRequest, ListReviewRequestEventResponse, ListingsApiService, MultilocationSendReviewRequestsCSVRequest, PagedRequestOptions, PagedResponseMetadata, RequestEventType, ReviewRequestEvent, ReviewRequestStatus, ReviewSources, SendReviewRequestEmailRequest, SendReviewRequestSmsRequest, SendReviewRequestToDefaultTemplateRequest, SendSMSRequest, SmsStatusCode, SortDirection, SortingOption, StartTrustHubRegistrationRequest, TwilioApiService, UpdateCustomerRequest };
